// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
      	filterTreeMobileStyle: 'style1'
	},
	template: {
		loadMoreLoading: '<div class="boost-pfs-filter-load-more-loading"><div class="load-more__icon" style="width: 44px; height: 44px; opacity: 1;"></div></div>',
	},
	selector: {
		breadcrumb: '.breadcrumb-collection'
	}
};

// Declare Templates
var boostPFSTemplate = {
  
  	'saleLabelHtml': '<div class="sale_banner thumbnail_banner">' + boostPFSConfig.label.sale + '</div>',
    'newLabelHtml': '<div class="new_banner thumbnail_banner">' + boostPFSConfig.label.new + '</div>',
    'preorderLabelHtml': '<div class="new_banner thumbnail_banner">' + boostPFSConfig.label.pre_order + '</div>',
    'bestSellingLabelHtml' : "<span class='buyers_label'>BUYER'S CHOICE</span>",
    'saletagLabelHtml' : '<span class="sale_label">SALE</span>',
    'newtagLabelHtml' : '<span class="new_label">NEW</span>',
    'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop ss-icon" data-gallery="product-{{itemId}}-gallery">+</span>',
    //'newRowHtml': '<br class="clear product_clear" />',

    // Grid Template
    'productGridItemHtml': '<div class="{{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupSmallClass}}" itemprop="itemListElement">' +
                             '<form method="post" name="cart_form" id="product-form-{{itemId}}" data-product-id="{{itemId}}" class="product_form_custom" >  ' +
                               '<div class="product-wrap">' +
                                    '<div class="relative product_image swap-' + boostPFSConfig.custom.secondary_image + '">' +
                                        '<a href="{{itemUrl}}" itemprop="url">' +
                                            '{{itemImages}}' +
                                        '</a>' +
                                        '<div class="thumbnail-overlay">' +
                                            '<a href="{{itemUrl}}" itemprop="url" class="hidden-product-link">{{itemTitle}}</a>' +
                                            '<div class="info">' +
                                                '{{itemProductInfoHover}}' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="banner_holder coll-bagde">' +
                                          '{{itemSaleLabel}}' +
                                          '{{itemNewLabel}}' +
                                          '{{itemPreorderLabel}}' +
                                          '{{itemBestSeller}}'+
                                        '</div>' +
                                    '</div>' +
                                    '<a class="product-info__caption {{itemHiddenClass}}" href="{{itemUrl}}" itemprop="url">' +
                                        '{{itemProductInfo}}' +
                                         ///'{{itemReviews}}' +
                                    '</a>' +
  
                                '</div>' +
                                '{{itemColorSwatches}}' +
                                '<input type="hidden" name="id" class="vid" value="{{itemvariId}}"/>' +
                                '{{itemQtyAddBtn}}' +
                             '</form>' +
                            '</div>' ,
                            //'{{itemNewRow}}',

    // Pagination Template
    'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + boostPFSConfig.label.paginate_prev + '</a></span>',
    'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + boostPFSConfig.label.paginate_next + ' »</a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<div class="sort-title active" value=""><span class="filter-arrow"></span>Sort by</div><ul class="sort_by" style="display: block;">{{sortingItems}}</ul>',
};


(function () { // Add this
	BoostPFS.inject(this); // Add this
	
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data, index) {
		if(!data) data = this.data;
		if (!index) index = this.index + 1; 

		/*** Prepare data ***/
		var images = data.images_info;
		if (images.length > 0) {
		data.featured_image = images[0];
		} else {
			data.featured_image = {
				'height': 1,
				'width': 1
			}
		}
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
      	var FirstvarImgs = data['variants'][0];
      
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
          var paramVariant = data.variants.filter(function (e) {
            return e.id == Utils.getParam('variant');
          });
          if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
          for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
              firstVariant = data['variants'][i];
              break;
            }
          }
        }
		/*** End Prepare data ***/
      
      	var is_engravable = false;
        $.each(data.tags, function(i, item) {
          if(item == 'Engravable'){
            is_engravable = true;
          }
        });

		// Get Template

        if(data.product_type != 'Mystery Earrings' && data.product_type != 'Mystery Necklace' && data.product_type != 'PPLR_HIDDEN_PRODUCT'){
          var itemHtml = boostPFSTemplate.productGridItemHtml;
        } else {
          var itemHtml = '';
        }


        var onSaleClass = onSale ? 'sale' : '';
        var soldOutClass = soldOut ? 'out_of_stock' : 'in_stock';

        // Add custom class
        var itemColumnNumberClass = '';
        var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, boostPFSConfig.custom.products_per_row);
        var itemCollectionGroupLargeClass = '';
        var itemCollectionGroupMediumClass = '';
        var itemCollectionGroupSmallClass = (index - 1) % 2 == 0 ? 'even' : 'odd';
        if (boostPFSConfig.custom.sidebar) {
          switch (boostPFSConfig.custom.products_per_row) {
            case 2: itemColumnNumberClass = 'six columns'; break; 
            case 3: itemColumnNumberClass = 'four columns'; break; 
            default: itemColumnNumberClass = 'three columns'; break; 
          }
        } else {
          switch (boostPFSConfig.custom.products_per_row) {
            case 2: itemColumnNumberClass = 'eight columns'; break;
            case 3: itemColumnNumberClass = 'one-third column'; break;
            case 4: itemColumnNumberClass = 'four columns'; break;
            case 5: itemColumnNumberClass = 'one-fifth column'; break;
            case 6: itemColumnNumberClass = 'one-sixth column'; break;
            default: itemColumnNumberClass = 'one-seventh column'; break;
          }
        }
        itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);    
        itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);
        itemHtml = itemHtml.replace(/{{itemCollectionGroupLargeClass}}/g, itemCollectionGroupLargeClass);
        itemHtml = itemHtml.replace(/{{itemCollectionGroupMediumClass}}/g, itemCollectionGroupMediumClass);    
        itemHtml = itemHtml.replace(/{{itemCollectionGroupSmallClass}}/g, itemCollectionGroupSmallClass);

        // Add soldOut label
        var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
        itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

        // Add onSale label
        var itemSaleLabel = boostPFSConfig.custom.sale_banner_enabled && onSale ? boostPFSTemplate.saleLabelHtml : '';
        itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

        // Add Label (New, Coming soon, Pre order)
        var newLabel = data.collections.filter(function(e) { return e.handle == 'new'; });
        var preorderLabel = data.collections.filter(function(e) { return e.handle == 'pre-order'; });
        var comingsoonLabel = data.collections.filter(function(e) { return e.handle == 'coming-soon'; });
        if (data.collections) {
          var itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? boostPFSTemplate.newLabelHtml : '';
          itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);

          var itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? boostPFSTemplate.comingsoonLabelHtml : '';
          itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);

          var itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? boostPFSTemplate.preorderLabelHtml : '';
          itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);
        }

        var bestSelling = '';

        if(data.tags.includes('Best Seller')){
          bestSelling = boostPFSTemplate.bestSellingLabelHtml;
        }
        else if(data.tags.includes('Best Seller') && data.tags.includes('New') ){
          bestSelling = boostPFSTemplate.bestSellingLabelHtml;
        }
        else if(data.tags.includes('Baby_Final_Sale') || data.tags.includes('Kids_Final_Sale') || data.tags.includes('Teen_Final_Sale')){
          bestSelling = boostPFSTemplate.saletagLabelHtml;
        }
        else if(data.tags.includes('Baby_Final_Sale') || data.tags.includes('Kids_Final_Sale') || data.tags.includes('Teen_Final_Sale') && data.tags.includes('New')){
          bestSelling = boostPFSTemplate.saletagLabelHtml;
        }      
        else if(data.tags.includes('New')){
          bestSelling = boostPFSTemplate.newtagLabelHtml;
        }

        itemHtml = itemHtml.replace(/{{itemBestSeller}}/g, bestSelling); 

        var product_personalize_hide_show_class = "";
        if(data.tags.includes('Design')){
          product_personalize_hide_show_class = "hide_purcahse_box";
        }

        itemHtml = itemHtml.replace(/{{personalize_box_btn}}/g, product_personalize_hide_show_class);  

        var itemHiddenClass = boostPFSConfig.custom.thumbnail_hover_enabled ? 'hidden' : '';
        itemHtml = itemHtml.replace(/{{itemHiddenClass}}/g, itemHiddenClass);        


        // Get image source
        var itemImageSrc = 'data-src="' + Utils.getFeaturedImage(images, '900x') + '" ';
        itemImageSrc += 'data-srcset=" ' + Utils.getFeaturedImage(images, '300x') + ' 300w,';
        itemImageSrc += Utils.getFeaturedImage(images, '400x') + ' 400w,';
        itemImageSrc += Utils.getFeaturedImage(images, '500x') + ' 500w,';
        itemImageSrc += Utils.getFeaturedImage(images, '600x') + ' 600w,';
        itemImageSrc += Utils.getFeaturedImage(images, '700x') + ' 700w,';
        itemImageSrc += Utils.getFeaturedImage(images, '800x') + ' 800w,';
        itemImageSrc += Utils.getFeaturedImage(images, '900x') + ' 900w"';
        // Get Thumbnail url
        var itemThumbUrl = Utils.getFeaturedImage(images, '100x');
        

        // Add Thumbnail
        var product_set_width = data.featured_image.width;
        var align_height_value = '';
        if (boostPFSConfig.custom.align_height) {
          if (images.length > 0) {
            var collection_height = boostPFSConfig.custom.collection_height;
            var product_aspect_ratio = images[0]['width'] / images[0]['height'];
            product_set_width = product_aspect_ratio * collection_height;
            if (images[0]['width'] >= images[0]['height']) {
              align_height_value = 'width: 100%; height: auto;';
            } else {
              align_height_value = 'width: 100%;';
            }
          }
        }

        var found_match;
        var flip_img_found;
        data.tags.forEach(function(arr){
          if(arr.includes('IMG')){
            found_match = arr;
          }
          
          if(arr.includes('Hover_IMG')){
            flip_img_found = arr;
          }
        })

        var img_index;

        if(found_match != undefined){
          img_index = parseInt(found_match.replace("IMG",'')) - 1;
        }

        if(img_index != undefined){

          if(images.length > img_index){
            var pd_img = images[img_index]['src'];
          }
          else{
            var pd_img = FirstvarImgs.image;
          }

          if(pd_img !== null && pd_img !== ''){
            var prImg = pd_img.split(/\.(?=[^\.]+$)/);
          }else{
            var pd_img = images[0] ? images[0]['src'] : '';
            var prImg = pd_img.split(/\.(?=[^\.]+$)/);
          }
          var im1 = prImg[0] + "_300x.";
          var im2 = prImg[1];

          var result = 'data-src="' + prImg[0] + '_900x.' + im1 + ' 900w," ';
          result += 'data-srcset="'+ prImg[0] + "_300x." + im2 + ' 300w,';
          result += prImg[0] + "_400x." + im2 + " 400w,";
          result += prImg[0] + "_500x." + im2 + " 500w,";
          result += prImg[0] + "_700x." + im2 + " 700w,";
          result += prImg[0] + "_900x." + im2 + ' 900w," ';
          result += 'srcset="' + prImg[0] + '_400x.' + im2 + ' 400w," ';

          var mainImg = prImg[0] + "_400x." + im2 + " 400w,";

        }
        else {
          var str = FirstvarImgs.image;
          if(str != null){

            var res = str.split(/\.(?=[^\.]+$)/);
            var i1 = res[0] + "_300x.";
            var i2 = res[1];
            var result = 'data-src="' + res[0] + '_900x.' + i2 + ' 900w," ';
            result += 'data-srcset="'+ res[0] + "_300x." + i2 + ' 300w,';
            result += res[0] + "_400x." + i2 + " 400w,";
            result += res[0] + "_500x." + i2 + " 500w,";
            result += res[0] + "_700x." + i2 + " 700w,";
            result += res[0] + "_900x." + i2 + ' 900w," ';
            result += 'srcset="' + res[0] + '_400x.' + i2 + ' 400w," ';

            var mainImg = res[0] + "_400x." + i2 + " 400w,";
          }
          else{
            var result = itemImageSrc;
            var mainImg = itemThumbUrl;
          }
        }
      
        
        if(data.tags.includes('ImageSize95')){
          var img_size_set = 'ImageSize95';
        }
        else if(data.tags.includes('ImageSize90')){
          var img_size_set = 'ImageSize90';
        }
        else if(data.tags.includes('ImageSize85')){
          var img_size_set = 'ImageSize85';
        }
        else if(data.tags.includes('ImageSize80')){
          var img_size_set = 'ImageSize80';
        }
        else if(data.tags.includes('ImageSize75')){
          var img_size_set = 'ImageSize75';
        }
        else if(data.tags.includes('ImageSize70')){
          var img_size_set = 'ImageSize70';
        }
        else if(data.tags.includes('ImageSize65')){
          var img_size_set = 'ImageSize65';
        }
      
        var itemImagesHtml = '<div class="image__container" style="max-width: ' + product_set_width + 'px;">';
        itemImagesHtml += '<img src="' + mainImg + '"' +
                                ' alt="{{itemTitle}}" ' +
                                ' class="pro-i-image none lazyload '+img_size_set+' '+ boostPFSConfig.custom.image_loading_style + '"' +
                                ' style="' + align_height_value + ' max-width: ' + data.featured_image.width + 'px;"' +
                                ' data-sizes="auto" ' + result  + '/>';
        itemImagesHtml += '</div>';
      
        // Add Flip Image
        var flip_img_index;

        if(flip_img_found != undefined){
          flip_img_index = parseInt(flip_img_found.replace("Hover_IMG",'')) - 1;
        }
        else{
          if(images.length > 2){
            flip_img_index = 2
          }
          else{
            flip_img_index = 0
          }
        }    

        if(images.length > flip_img_index){
          var flImg = images[flip_img_index]['src'];
          var prsecImg = flImg.split(/\.(?=[^\.]+$)/);
          var flip_img_Url = prsecImg[0] + "_400x." + prsecImg[1] + " 400w,";
        }
      
       // var itemFlipImageUrl = images.length > 2 ? Utils.optimizeImage(images[2]['src']) : Utils.getFeaturedImage(images, '900x');
      
        if (boostPFSConfig.custom.secondary_image) {
            itemImagesHtml += '<div class="image__container" style="max-width:';
            if (images.length > 1) {
                itemImagesHtml += images[1]['width'] + 'px">';
            } else {
                itemImagesHtml += data.featured_image.width + 'px">';
            }
            itemImagesHtml +=  '<img src="' + flip_img_Url + '" class="secondary lazyload" alt="{{itemTitle}}" />';
            itemImagesHtml += '</div>';
        }
        // Old version: none aspect_ratio
        // itemImagesHtml +=  '<img src="' + itemThumbUrl + '" alt="{{itemTitle}}" class="lazyload ' + boostPFSConfig.custom.image_loading_style + '" data-sizes="auto" ' + itemImageSrc + ' />';
        // if (boostPFSConfig.custom.secondary_image) {
        //     itemImagesHtml += '<img src="' + itemFlipImageUrl + '" class="secondary lazyload" />';
        // }
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

        // Build Quick shop button
        var priceAttr = typeof comingsoonLabel == 'undefined' ? boostPFSConfig.label.coming_soon : Utils.formatMoney(firstVariant.money);
        var fullDescAttr = data.description !== null ? 'data-full-description="' + Utils.escape(data.description.split('<!-- split -->')[0]) + '"' : 'data-full-description';
        var regularDescAttr = data.description !== null ? 'data-regular-description="' + Utils.escape(Utils.truncateByWord(data.description, boostPFSConfig.custom.description_words).replace('Description', '').replace('Dimensions', '').replace('Details', '').replace('Specs', '').replace('Shipping', '').replace('Size', '')) + '"' : 'data-regular-description';
        var imageAttr = '';
        for (var k in images) {
            imageAttr += images[k]['id'] + ' || ' + data.title + ' ||';
        }
        var colHandleAttr = '';
        for (var k in data.collections) {
            colHandleAttr += data['collections'][k]['handle'];
            if (k < data.collections.length - 1) {
                colHandleAttr += ',';
            }
        }
        var dataImages = "data-images='" + imageAttr + "'";
        var quickShopBtnHtml = '<span class="quick_shop ss-icon js-quick-shop-link"' +
                                    ' data-no-instant' +
                                    ' data-remodal-target="quick-shop"' +
                                    ' data-id="{{itemId}}"' +
                                    ' data-handle="{{itemHandle}}"' +
                                    ' data-money-format="' + Globals.moneyFormat + '"' +
                                    ' data-formatted-price="' + priceAttr + '"' +
                                    ' data-url="{{itemUrl}}"' +
                                    ' data-title="{{itemTitle}}"' +
                                    ' data-details-text="' + Utils.escape(boostPFSConfig.label.view_detail) + '"' +
                                    ' ' + fullDescAttr +
                                    ' ' + regularDescAttr +
                                    dataImages + 
                                    ' data-collection-handles="' + colHandleAttr + '"' +
                                '>' +
                                    boostPFSConfig.label.quick_shop +
                                '</span>';

        // Build Product Info when hovering 
        var itemProductInfoHoverHtml = '';
        if (boostPFSConfig.custom.thumbnail_hover_enabled && boostPFSConfig.custom.quick_shop_enabled) {
            itemProductInfoHoverHtml += '{{itemProductInfo}}';
            itemProductInfoHoverHtml += quickShopBtnHtml;
        } else {
            if (boostPFSConfig.custom.thumbnail_hover_enabled) {
                itemProductInfoHoverHtml += '{{itemProductInfo}}';
            } else if (boostPFSConfig.custom.quick_shop_enabled) {
                itemProductInfoHoverHtml += quickShopBtnHtml;
            }
        }
        itemHtml = itemHtml.replace(/{{itemProductInfoHover}}/g, itemProductInfoHoverHtml);

        // Build Product Info (product-info.liquid)
        if(is_engravable == true){
          var prodId_json = "{{data.id | json}}";
          var prodFvarint = data.variants[0].id;
          var prod_Url = boostPFSConfig.shop.url+Utils.buildProductItemUrl(data);
          
          var itemProductInfoHtml = '<div class="product-details">';
          itemProductInfoHtml += '<span class="personalize_txt">Personalize It!</span>';
          itemProductInfoHtml += '<span class="title" itemprop="name">{{itemTitle}}</span>';
          //itemProductInfoHtml += '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_'+data.id+'" data-swaction="addToWishlist" data-product-id="'+data.id+'" data-variant-id="'+data.variants[0].id+'" data-product-url="'+prod_Url+'"></button>';
          itemProductInfoHtml += '{{itemVendor}}';
          if(data.available == true && boostPFSConfig.custom.price_enable == true ){
            itemProductInfoHtml += '{{itemPrice}}';
          }
          itemProductInfoHtml += '</div>';
          itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
          itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, itemProductInfoHtml);
        }else{
          var prodId_json = "{{data.id | json}}";
          var prodFvarint = data.variants[0].id;
          var prod_Url = boostPFSConfig.shop.url+Utils.buildProductItemUrl(data);
          
          var itemProductInfoHtml = '<div class="product-details">';
          itemProductInfoHtml += '<span class="title" itemprop="name">{{itemTitle}}</span>';
          //itemProductInfoHtml += '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_'+data.id+'" data-swaction="addToWishlist" data-product-id="'+data.id+'" data-variant-id="'+data.variants[0].id+'" data-product-url="'+prod_Url+'"></button>';
          itemProductInfoHtml += '{{itemVendor}}';
          if(data.available == true && boostPFSConfig.custom.price_enable == true ){
            itemProductInfoHtml += '{{itemPrice}}';
          }  
          itemProductInfoHtml += '</div>';
          itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
          itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, itemProductInfoHtml);
        }

        //Add Review badge
     /// itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReviews(data));

      // Build Domain
      itemHtml = itemHtml.replace(/{{itemDomain}}/g, Utils.escape(boostPFSAppConfig.shop.domain));

      // Build Description
      var itemDescription = data.description;
      itemDescription = itemDescription.substr(0, itemDescription.indexOf('##highlights##'));
      itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

      // Add Vendor
        var itemVendorHtml = '';
        if (boostPFSConfig.custom.vendor_enable) {
            itemVendorHtml = '<span itemprop="brand" class="brand">' + data.vendor + '</span>';
        }
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

        // Add Price
        var itemPriceHtml = '';
        if(typeof comingsoonLabel[0] !== 'undefined') {
          itemPriceHtml += '<span class="modal_price">' + boostPFSConfig.label.coming_soon + '</span>';
        }
        else{
          
          if(boostPFSConfig.custom.auto_discount == true && boostPFSConfig.custom.disc_percentage > 0 ){
            var disc_per = boostPFSConfig.custom.disc_percentage;
            var org_price = data.price_min;
            var disc_price = org_price - (org_price * disc_per / 100);
            var saleClass = org_price > disc_price ? 'sale' : '';

            var has_dis_col = false;
            $.each(data.collections,function(index, coll){
              if(coll.handle == boostPFSConfig.custom.disc_collection){
                has_dis_col = true;
              }
            });

            //itemPriceHtml += '<span>'+has_dis_col+'</span>';

            if(boostPFSConfig.custom.disc_apply == 'selected_collection' && boostPFSConfig.custom.disc_collection != "" && has_dis_col == true){
              itemPriceHtml += '<span class="price ' + saleClass + '">';
              
              /*if(data.compare_at_price_max > 0){
                itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(org_price) + '</span></span>';
              }
              else{
                if(org_price > disc_price) {
                  itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(org_price) + '</span></span>';
                }
              }*/

              if(!soldOut) {
                if(data.compare_at_price_max > 0){
                  itemPriceHtml += '<span class="money" onload="convertCurrencies()">' + Utils.formatMoney(disc_price) + '</span>';
                }
                else{
                  itemPriceHtml += '<span class="money" onload="convertCurrencies()">' + Utils.formatMoney(disc_price) + '</span>';
                } 

                /*if(data.compare_at_price_max > 0){
                  var pr1 = org_price - disc_price;
                  var pr2 = pr1 * 100.0;
                  var pr3 = pr2 / org_price;
                  var discount = pr3.toFixed(0);
    
                  itemPriceHtml += '<div class="sale-discount">ENJOY '+discount+'% OFF</div>';
                }
                else{
                  if(org_price > disc_price) {
                    var pr1 = org_price - disc_price;
                    var pr2 = pr1 * 100.0;
                    var pr3 = pr2 / org_price;
                    var discount = pr3.toFixed(0);
  
                    itemPriceHtml += '<div class="sale-discount">ENJOY '+discount+'% OFF</div>';
                  }
                }*/
              } 
              else {
                itemPriceHtml += '<span class="sold_out">' + boostPFSConfig.label.sold_out + '</span>';
              }
              itemPriceHtml += '</span>';
              itemPriceHtml += '<small class="base_price" data-first-variant="' + firstVariant.id + '"></small>';
            }
              
            else if(boostPFSConfig.custom.disc_apply == 'all_products' ){
              itemPriceHtml += '<span class="price ' + saleClass + '">';
              
              /*if(data.compare_at_price_max > 0){
                itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(org_price) + '</span></span>';
              }
              else{
                if(org_price > disc_price) {
                  itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(org_price) + '</span></span>';
                }
              }*/

              if(!soldOut) {
                if(data.compare_at_price_max > 0){
                  itemPriceHtml += '<span class="money" onload="convertCurrencies()">' + Utils.formatMoney(disc_price) + '</span>';
                }
                else{
                  itemPriceHtml += '<span class="money" onload="convertCurrencies()">' + Utils.formatMoney(disc_price) + '</span>';
                } 

               /* if(data.compare_at_price_max > 0){
                  var pr1 = org_price - disc_price;
                  var pr2 = pr1 * 100.0;
                  var pr3 = pr2 / org_price;
                  var discount = pr3.toFixed(0);
    
                  itemPriceHtml += '<div class="sale-discount">ENJOY '+discount+'% OFF</div>';
                }
                else{
                  if(org_price > disc_price) {
                    var pr1 = org_price - disc_price;
                    var pr2 = pr1 * 100.0;
                    var pr3 = pr2 / org_price;
                    var discount = pr3.toFixed(0);
  
                    itemPriceHtml += '<div class="sale-discount">ENJOY '+discount+'% OFF</div>';
                  }
                }*/
              } 
              else {
                itemPriceHtml += '<span class="sold_out">' + boostPFSConfig.label.sold_out + '</span>';
              }
              itemPriceHtml += '</span>';
              itemPriceHtml += '<small class="base_price" data-first-variant="' + firstVariant.id + '"></small>';
            }
            else{
              itemPriceHtml += '<span class="price ' + onSaleClass + '">';
              
              // if(onSale) {
              //   itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(data.compare_at_price_max) + '</span></span>';
              // }
          
              if(!soldOut) {
                if(data.price_min > 0) {
                  itemPriceHtml += '<span class="money" onload="convertCurrencies()">' + Utils.formatMoney(data.price_min) + '</span>';
                } else {
                  itemPriceHtml += boostPFSConfig.label.free_price;
                }
    
               /* if(onSale) {
                  var pr1 = data.compare_at_price_min - data.price_min;
                  var pr2 = pr1 * 100.0;
                  var pr3 = pr2 / data.compare_at_price_min;
                  var discount = pr3.toFixed(0);
    
                  itemPriceHtml += '<div class="sale-discount">ENJOY '+discount+'% OFF</div>';
                }*/
              } 
              else {
                itemPriceHtml += '<span class="sold_out">' + boostPFSConfig.label.sold_out + '</span>';
              }
              itemPriceHtml += '</span>';
              itemPriceHtml += '<small class="base_price" data-first-variant="' + firstVariant.id + '"></small>';
            }
          }
          else{
            itemPriceHtml += '<span class="price ' + onSaleClass + '">';
            
            // if(onSale) {
            //   itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(data.compare_at_price_max) + '</span></span>';
            // }
          
            if(!soldOut) {
              if(data.price_min > 0) {
                itemPriceHtml += '<span class="money" onload="convertCurrencies()">' + Utils.formatMoney(data.price_min) + '</span>';
              } else {
                itemPriceHtml += boostPFSConfig.label.free_price;
              }
  
              /*if(onSale) {
                var pr1 = data.compare_at_price_min - data.price_min;
                var pr2 = pr1 * 100.0;
                var pr3 = pr2 / data.compare_at_price_min;
                var discount = pr3.toFixed(0);
  
                itemPriceHtml += '<div class="sale-discount">ENJOY '+discount+'% OFF</div>';
              }*/
            } 
            else {
              itemPriceHtml += '<span class="sold_out">' + boostPFSConfig.label.sold_out + '</span>';
            }
            itemPriceHtml += '</span>';
            itemPriceHtml += '<small class="base_price" data-first-variant="' + firstVariant.id + '"></small>';
          }
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

        // Add Swatches
        var itemColorSwatchesHtml = '';
        if (boostPFSConfig.custom.collection_swatches) {
            for (var k in data.options) {
                var option = data['options'][k];
                var downcasedOption = option.toLowerCase();
                var styleTypes = ['style','pearl_size'];
                var colorTypes = ['color', 'colour', 'farve'];
              
                if($(window).width() <= 767) { 
                  var count = data.variants.length; 
                }else{ 
                  var count = data.variants.length; 
                }
              
                if(styleTypes.indexOf(downcasedOption) > -1) {
                  var option_index = k;
                  var values = [];
                  
                  itemColorSwatchesHtml += '<div class="swatch collection_swatches is_style" data-option-index="'+option_index+'">';
                  itemColorSwatchesHtml += '<div class="swatch-clr-opt">'
                    for(var i in data.variants) {
                     // if(i < count){
                        var variant = data['variants'][i];
                        var value = variant['options'][option_index];
                        //  if(i == 0){
                        //  var mainColor = getMainVariant(data);
                        //  if (mainColor.length > 0) {
                        //  itemColorSwatchesHtml += mainColor[0].html;
                        //  var values = values.join(','); 
                        //  values += ',' + mainColor[0].value;
                        //  values = values.split(',');
                        //  }
                        //  } 
                        
                        if(values.indexOf(value) == -1){
                          var variant_avail;
                          
                          if(variant.available){ 
                            variant_avail = "available";
                          }
                          else { 
                            variant_avail = "soldout" 
                          };

                          var values = values.join(',');
                          values += ',' + value;
                          values = values.split(',');
                          var fileColorUrl = boostPFSAppConfig.general.asset_url.replace('boost-pfs-filter.js', Utils.slugify(value) + '.png');
                          fileColorUrl = Utils.optimizeImage(fileColorUrl, '50x');
                          
                          // if(i == 0){
                          // itemColorSwatchesHtml += '<input id="swatch-index-'+value+'-'+data.id+'" type="radio" name="option-'+option_index+'" value="'+value+'" checked />';
                          // }
                          // else{
                          // itemColorSwatchesHtml += '<input id="swatch-index-'+value+'-'+data.id+'" type="radio" name="option-'+option_index+'" value="'+value+'" />';
                          // }
                          
                          itemColorSwatchesHtml += '<div data-value="'+value+'" class="swatch-element is_style_swatch '+value+'-swatch '+value+' '+ variant_avail +'" data-variant="'+variant.id+'" data-price="'+Utils.formatMoney(variant.price)+'" data-image="' + Utils.optimizeImage(variant.image, '400x') + '" title="'+value+'">';
                          itemColorSwatchesHtml += '<label style="background-image: url(' + Utils.optimizeImage(variant.image, '64x') + ')"; >'+value+'<span class="crossed-out"><img src="https://cdn.shopify.com/s/files/1/0446/9345/files/soldout_grey.png?v=1589965443"></span></label>';
                          itemColorSwatchesHtml += '</div>';
                          // itemColorSwatchesHtml += '<a href="' + bcsffilter.buildProductItemUrl(data) + '?variant=' + variant.id + '" class="swatch is_style_swatch';
                          // itemColorSwatchesHtml += '" data-swatch-name="meta-' + downcasedOption + '_' + (value.replace(/\s/g, '_')).toLowerCase() + '">';
                          // itemColorSwatchesHtml += '<span data-image="' + bcsffilter.optimizeImage(variant.image, '400x') + '">'+ value +'</span>';
                          // itemColorSwatchesHtml += '</a>';
                        }
                      //}
                    }

                    // if(data.variants.length > count){
                    //   itemColorSwatchesHtml += '<div class="swatch-count"><a href="'+Utils.buildProductItemUrl(data)+'">'+'+'+parseInt(data.variants.length - count)+'</a></div>';
                    // }
                  
                    itemColorSwatchesHtml += '</div>'; 
                  
                    var tag_match;
                    data.tags.forEach(function(arr){
                      if(arr.includes('option_')){
                        tag_match = arr;
                      }
                    });
                    
                    if(tag_match != undefined){
                      var opt_tag = tag_match.replace("option_",'');
                      itemColorSwatchesHtml += '<div class="variant-opt-count"><a href="'+Utils.buildProductItemUrl(data)+'">'+ data.variants.length+' '+opt_tag+'</a></div>';  
                    }
                  
                    itemColorSwatchesHtml += '</div>';
                }

                if(colorTypes.indexOf(downcasedOption) > -1 && data.variants.length > 1) {
                  var option_index = k;
                  var values = [];
                  
                  itemColorSwatchesHtml += '<div class="swatch collection_swatches is_style" data-option-index="'+option_index+'">';
                  itemColorSwatchesHtml += '<div class="swatch-clr-opt">'
                    for(var i in data.variants){
                      if(i < count){
                        var variant = data['variants'][i];
                        var value = variant['options'][option_index];
                        
                        if(values.indexOf(value) == -1) {
                          var variant_avail;
                          
                          if(variant.available){ 
                            variant_avail = "available";
                          }else { 
                            variant_avail = "soldout" 
                          };
                          
                          var values = values.join(',');
                          values += ',' + value;
                          values = values.split(',');
                          var fileColorUrl = boostPFSConfig.general.asset_url.replace('boost-pfs-filter.js', Utils.slugify(value) + '.png');
                          fileColorUrl = Utils.optimizeImage(fileColorUrl, '50x');
                          itemColorSwatchesHtml += '<div data-value="'+value+'" data-index="'+i+'" class="swatch-element is_style_swatch '+value+'-swatch '+ variant_avail +'" data-variant="'+variant.id+'" data-price="'+Utils.formatMoney(variant.price)+'" data-image="' + Utils.optimizeImage(variant.image, '400x') + '" title="'+value+'">';
                          itemColorSwatchesHtml += '<label style="background-image: url(' + Utils.optimizeImage(variant.image, '64x') + ')"; >'+value+'<span class="crossed-out"><img src="https://cdn.shopify.com/s/files/1/0446/9345/files/soldout_grey.png?v=1589965443"></span></label>';
                          itemColorSwatchesHtml += '</div>';
                        }
                      }
                    }
                  
                    if(data.variants.length > count){
                      itemColorSwatchesHtml += '<div class="swatch-count"><a href="'+Utils.buildProductItemUrl(data)+'">'+'+'+parseInt(data.variants.length - count)+'</a></div>';
                    }

                    itemColorSwatchesHtml += '</div>'; 

                    var tag_match;
                    data.tags.forEach(function(arr){
                      if(arr.includes('option_')){
                        tag_match = arr;
                      }
                    });

                    if(tag_match != undefined){
                      var opt_tag = tag_match.replace("option_",'');
                      itemColorSwatchesHtml += '<div class="variant-opt-count"><a href="'+Utils.buildProductItemUrl(data)+'">'+ data.variants.length+' '+opt_tag+'</a></div>';  
                    }
                    itemColorSwatchesHtml += '</div>';
                }

            }
        }
        itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, itemColorSwatchesHtml);

        // Add new row
        //var itemNewRowHtml = index % boostPFSConfig.custom.products_per_row == 0 ? boostPFSTemplate.newRowHtml : '';
        //itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRowHtml);

        var addBtnHtml = '';

        if(data.available == true && boostPFSConfig.custom.addtocart_enable == true ){
          addBtnHtml =  '<div class="product-add-qty">'+
            '<div class="product-quantity-btn">'+
            '<span class="ss-icon qty-minus " ><span class="icon-minus"></span></span>'+
            '<input type="number" class="quantity qty_val" max="{{itemvari_itemvari}}" name="quantity" value="1">' +
            '<span class="ss-icon qty-plus " ><span class="icon-plus"></span></span>'+
            '</div>'+

            '<button type="submit" name="add" class="action_button add_custom_cart add_to_cart" data-label="Add to Cart"><span class="text">Add to Cart</span>'+
            '<svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark">'+
            '<path fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"/>'+
            '</svg></button>' +
            '</div>';
        }
        itemHtml = itemHtml.replace(/{{itemQtyAddBtn}}/g,addBtnHtml);

		// Add main attribute
        var prod_title;
        if(Utils.getProductMetafield(data, 'global', 'short_title') !== null) {
          prod_title = Utils.getProductMetafield(data, 'global', 'short_title');
        }else{
         prod_title =  data.title;
        }
      
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, prod_title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{itemvariId}}/g,data.variants[0].id);

		return itemHtml;
	};

    setTimeout(function() {
      $('.collection_swatches').siblings(".product-wrap").addClass("product_variant_show");
    }, 3000);
  
    function buildReviews(data) {
      // Build Labels
      var html = '';
      var regex = /\s\d+\s(?:review|reviews)\s/;
      if (Utils.getProductMetafield(data, 'judgeme', 'badge') !== null) {
        html = "<div class='jdgm-widget jdgm-preview-badge' data-id='" + data.id + "'>" + Utils.getProductMetafield(data, 'judgeme', 'badge') + "</div>";
      }

      var element = html.match(regex);
      if (element != null) {
        var newElement = ' (' + element[0].match(/\d+/)[0] + ') ';
        return html.replace(regex, newElement)
      }
      return html;
    }

    // Build advanced class
    function buildItemCollectionGroupThumbClass(index, productsPerRow) {
      var temp = index < productsPerRow ? index : index % productsPerRow;
      if (temp == 0) { return 'omega'; }
      else if (temp == 1) { return 'alpha'; }
      return '';
    }

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		// Get page info
      	if (!totalProduct) totalProduct = this.totalProduct;
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}
		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content 
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);

				return html;
			}
		}
		return '';
	};
  
	// Sorting render
	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());
		var $selectInput = jQ(Selector.topSorting);
		if ($selectInput.length) {
		$selectInput.val(Globals.queryParams.sort);
		}
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		var _this = this;
		jQ(Selector.topSorting).change(function (e) {
			// Append "sort" param to url
			// Used to Scroll to the previous position after returning from Product page
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.applyFilter('sort');
		})
	};

	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData, apiData) {
		if (!colData) colData = this.collectionData;
		if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
			var colInfo = colData.collection;

			var breadcrumbHtml = '<span ><a href="' + boostPFSConfig.shop.url + '" title="' + boostPFSConfig.shop.name + '" class="breadcrumb_link"><span>' + boostPFSConfig.label.breadcrumb_home + '</span></a></span> ';
			breadcrumbHtml += '<span class="breadcrumb-divider">/</span> ' +
				'<span><a href="{{currentCollectionLink}}" title="{{currentCollectionTitle}}" class="breadcrumb_link"><span>{{currentCollectionTitle}}</span></a></span> ';
			// Build Tags
			var currentTagsHtml = '';
			if (Array.isArray(boostPFSConfig.general.current_tags)) {
				var current_tags = boostPFSConfig.general.current_tags;
				for (var k = 0; k < current_tags.length; k++) {
					var tag = current_tags[k];
					currentTagsHtml += '<span class="breadcrumb-divider">/</span>';
					currentTagsHtml += '<span><a href="/collections/{{currentCollectionLink}}/' + Utils.slugify(tag) + '" title="' + tag + '"><span>' + tag + '</span></a></span>';
				}
			}
			breadcrumbHtml += currentTagsHtml;
			// Build Collection Info
			breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
			// Top Pagination
			breadcrumbHtml += ' <span class="boost-pfs-filter-top-pagination"></span>';
			return breadcrumbHtml;
		}
		return '';
	};

	// Call Theme function to Build additional elements for Product list
	ProductList.prototype.afterRender = function (data) {
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
		// Build Quick view data
		if (!data) data = this.data;
      
        if (typeof Yotpo !== 'undefined') {
            var api = new Yotpo.API(yotpo);
            api.refreshWidgets();
        }
	};

	// Build Additional elements
	Filter.prototype.afterRender = function (data) {
		if (!data) data = this.data;
		// Remove InstantClick
		jQ(Selector.filterTree).find('a').attr('data-no-instant', '');

		// Remove product wrapper
		if (jQ(Selector.products).children().hasClass('product-list')) {
			jQ(Selector.products).children().children().unwrap();
		}

		// Build top pagination
		var totalPage = Math.ceil(data.total_product / Globals.queryParams.limit);
		var topPaginationHtml = '<span class="breadcrumb-divider">/</span> ' + (boostPFSConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, Globals.queryParams.page).replace(/{{ pages }}/g, totalPage);
		jQ('.boost-pfs-filter-top-pagination').html(topPaginationHtml);
		jQ(".load-more__icon").remove();
      
        jQ('#sorting-wrap li').off('click').on('click', function(e) {
          e.preventDefault();
          jQ('#sorting-wrap li').removeClass('active');
          jQ(this).addClass('active');
          FilterApi.setParam('sort', jQ(this).attr('value'));
          FilterApi.setParam('page', 1);
          FilterApi.applyFilter('sort');

        });
      
      	jQ('.boost-pfs-filter-apply-all-button').off('click').on('click', function(){
          jQ('.filter-close-btn').trigger('click');
        })
        
        $('body').on('click','.sort-title',function(){
          $(this).toggleClass('active');
          $('.sort_by').slideToggle(400);
        });

      if(window.location.href.includes('sort=')) {
        jQ('.boost-pfs-filter-apply-all-button').addClass('apply-btn-selected')
      }

	};
  
  	FilterTree.prototype.afterRender = function () {
      	if (this.$filterOptionsContainerElement.find('#sorting-wrap').length < 1) {
          this.$filterOptionsContainerElement.append('<div id="sorting-wrap"></div>');
          var sortingHtml = '';
          var sortingArr = Utils.getSortingList();
          if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            var sortActive = '';
            var actived = Globals.queryParams.sort === '' || !Globals.queryParams.sort ? 'active' : '';
            for (var k in sortingArr) {
              var classActived = (Globals.queryParams.sort == k)?'active':'';
              if(Globals.queryParams.sort == k){
                sortActive = sortingArr[k];
              }
              sortingItemsHtml += '<li class="'+ classActived +' sort-default" value="' + k +'"><span></span>' + sortingArr[k] + '</li>';

            }
            sortingHtml = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
          }
          
          this.$filterOptionsContainerElement.find('#sorting-wrap').html(sortingHtml);
        }
      
      	if (this.$element.find('.boost-pfs-filter-selection-wrapper').length < 1) {
          this.$element.append('<div class="boost-pfs-filter-selection-wrapper"></div>');
        } else {
          this.$element.find('.boost-pfs-filter-selection-wrapper').html('');
        }
      
        // if (this.refineBy.$element) {
        if (this.refineBy !== null) {
          this.$element.find('.boost-pfs-filter-selection-wrapper').append(this.refineBy.$element);
        } else {
          this.$element.find('.boost-pfs-filter-selection-wrapper').append('<div class="boost-pfs-filter-refine-by"><div class="boost-pfs-filter-option-title"></div></div>');
        }
      
        if (this.$element.find('.filter-close-more').length < 1) {
          this.$element.find('.boost-pfs-filter-selection-wrapper').append('<div class="filter-close-more"><a href="javascript:void(0)" class="filter-close-btn" data-no-instant="" style="visibility: visible;"><span class="cl-icon"></span><span>Close</span></a></div>')
        }
      
      	if (this.$element.find('.boost-pfs-filter-selection-wrapper .boost-pfs-filter-clear-all').length < 1) {
          this.$element.find('.boost-pfs-filter-selection-wrapper .boost-pfs-filter-option-title').append(this.clearAllButton.$element);
        }

        if (this.$element.find('.boost-pfs-filter-selection-wrapper .boost-pfs-filter-apply-all-button').length < 1) {
          this.$element.find('.boost-pfs-filter-selection-wrapper .boost-pfs-filter-option-title').append('<button class="boost-pfs-filter-button boost-pfs-filter-apply-all-button">Apply All</button>');
        }

        // if (this.refineBy.refineByItems.length > 0) {
        if (Utils.checkExistFilterOptionParam()) {
          //             this.applyAllButton.$element.addClass('apply-btn-selected');
          this.$element.find('.boost-pfs-filter-apply-all-button').addClass('apply-btn-selected');
        }
      
    }
    
    FilterOption.prototype.afterRender = function () {
      if (this.$filterOptionTitleElement.find('.filter-arrow').length < 1) {
        this.$filterOptionTitleElement.append('<span class="filter-arrow"></span>');
      }
    }

})(); // Add this at the end



